import { SUPPORTED_LOCALES } from '@webgame/i18n';
import { useTranslator } from '../hooks/use-translator';
import { UiSelect } from './ui-select';

export function LanguageSwitcher() {
  const translator = useTranslator();
  return (
    <span class="language-switcher">
      <UiSelect
        testId="language-switcher"
        label={translator.t('common.language')}
        value={translator.locale}
        options={SUPPORTED_LOCALES.map((locale) => ({
          value: locale,
          label: translator.t(`languages.${locale}`),
        }))}
        onChange={(locale) => {
          void translator.setLocale(locale);
        }}
      />
    </span>
  );
}
